(function () {
  var PROGRESS = '<div class="tr-progress" role="progressbar" aria-label="Checking for updates"><span></span></div>';
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function fmtStatus(s) {
    return ({
      FULFILLED: 'Shipped', PARTIALLY_FULFILLED: 'Partially shipped',
      UNFULFILLED: 'Not shipped yet', IN_PROGRESS: 'Preparing', ON_HOLD: 'On hold',
      SCHEDULED: 'Scheduled', RESTOCKED: 'Restocked'
    })[s] || s || '—';
  }
  function fmtTag(t) {
    return ({
      InfoReceived: 'Info received', InTransit: 'In transit', OutForDelivery: 'Out for delivery',
      AttemptFail: 'Delivery attempt failed', Delivered: 'Delivered',
      AvailableForPickup: 'Available for pickup', Exception: 'Exception',
      Expired: 'Expired', Pending: 'Pending'
    })[t] || t || '';
  }
  function fmtTime(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? iso : d.toLocaleString();
  }

  function render(out, d, polling) {
    if (!d || !d.found) {
      out.innerHTML = '<p class="tr-msg tr-err">We couldn’t find that order. Please double-check the order number and the email used at checkout.</p>';
      return;
    }
    var h = '<div class="tr-card">';
    h += '<div class="tr-row"><span>Status</span><b>' + esc(fmtStatus(d.status)) + '</b></div>';

    var ships = d.shipments || [];
    if (!ships.length) {
      h += '<p class="tr-msg" style="margin-top:12px">Your order is confirmed and being prepared — no tracking yet. Check back once it ships.</p></div>';
      out.innerHTML = h;
      return;
    }

    ships.forEach(function (s, i) {
      h += '<div class="tr-ship">';
      if (ships.length > 1) h += '<div class="tr-ship-h">Parcel ' + (i + 1) + '</div>';
      if (s.carrier)         h += '<div class="tr-row"><span>Carrier</span><b>' + esc(s.carrier) + '</b></div>';
      if (s.tracking_number) h += '<div class="tr-row"><span>Tracking #</span><b>' + esc(s.tracking_number) + '</b></div>';
      if (s.tracking_url)    h += '<a class="tr-link" href="' + esc(s.tracking_url) + '" target="_blank" rel="noopener">View on carrier site →</a>';

      if (s.events === null) {
        /* timeline provider unavailable — carrier link above is the fallback */
      } else if (s.events.length === 0) {
        if (polling) {
          h += '<p class="tr-msg" style="margin-top:10px">Fetching the latest tracking — this can take a few seconds…</p>' + PROGRESS;
        } else {
          h += '<p class="tr-msg" style="margin-top:10px">Your parcel is registered — tracking updates will appear here shortly. Check back soon.</p>';
        }
      } else {
        h += '<ol class="tr-timeline">';
        s.events.slice().reverse().forEach(function (e) {
          h += '<li><div class="tr-tl-top"><b>' + esc(fmtTag(e.status)) + '</b><span>' + esc(fmtTime(e.time)) + '</span></div>';
          var sub = [e.message, e.location].filter(Boolean).map(esc).join(' · ');
          if (sub) h += '<div class="tr-tl-sub">' + sub + '</div>';
          h += '</li>';
        });
        h += '</ol>';
      }
      h += '</div>';
    });

    h += '</div>';
    out.innerHTML = h;
  }

  // "Still loading" = a shipment is registered but has no events yet (events === [])
  // → AfterShip is fetching from the carrier, so it's worth auto-retrying.
  function stillLoading(d) {
    return !!(d && d.found && (d.shipments || []).some(function (s) {
      return Array.isArray(s.events) && s.events.length === 0;
    }));
  }

  // Query, render, and AUTO-RETRY while a parcel's timeline is still loading — the
  // backend registers the tracking with AfterShip on the first lookup (async), so the
  // very first query can come back empty; re-query a few times so the customer never
  // has to press Track twice. (We register on lookup, not for every order, to keep
  // AfterShip quota/cost down — hence this client-side retry.)
  function query(order, email, out, attempt) {
    return fetch('/apps/promo/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_name: order, email: email })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        var willRetry = stillLoading(d) && attempt < 4;
        render(out, d, willRetry);
        if (willRetry) {
          var delays = [6000, 10000, 15000, 20000]; // ~6s, 10s, 15s, 20s
          setTimeout(function () { query(order, email, out, attempt + 1); }, delays[attempt] || 20000);
        }
      })
      .catch(function () {
        if (attempt === 0) {
          out.innerHTML = '<p class="tr-msg tr-err">Tracking is temporarily unavailable. Please try again shortly.</p>';
        }
      });
  }

  function init() {
    var f = document.querySelector('[data-track-form]');
    var out = document.querySelector('[data-track-result]');
    if (!f || f.dataset.bound) return;
    f.dataset.bound = '1';
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var order = (f.order.value || '').trim();
      var email = (f.email.value || '').trim();
      if (!order || !email) return;
      out.innerHTML = '<p class="tr-msg">Looking up your order…</p>' + PROGRESS;
      query(order, email, out, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
